export const SET_ADDRESS_DATA = "SET_ADDRESS_DATA";
export const SELECTED_NEW_ADDRESS = "SELECTED_NEW_ADDRESS";
export const SELECTED_SAVED_ADDRESS = "SELECTED_SAVED_ADDRESS";

export const SET_SELECTED_ADDRESS_TYPE = "SET_SELECTED_ADDRESS_TYPE";
export const SET_TEMP_ADDRESS = "SET_TEMP_ADDRESS";
export const SETADDRESSDATA = (data: any) => {
  return {
    type: SET_ADDRESS_DATA,
    payload: data,
  };
};

const initialState: any = {
  address: [],
};

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ADDRESS_DATA:
      return {
        ...state,
        address: payload,
      };

    default:
      return state;
  }
};

export default reducer;
